<script setup lang="ts">
/* UTILS */
import { storeToRefs } from "pinia"

/* COMPONENTS */
import NotPassedAssessment from "@/components/af/NotPassedAssessment/NotPassedAssessment.vue"
import HelpAudioBox from "@/components/af/Help/HelpAudioBox.vue"
import LangMenu from "@/components/af/LangMenu/LangMenu.vue"

import { useHeaderControlsStore } from "@/components/af/HeaderControls/HeaderControls.store"
/* STORES */
import { useHelpStore } from "@/components/af/Help/help.store"
import { useUserStore } from "@/stores/user"

const { isActiveAudioBox } = storeToRefs(useHelpStore())
const { getIsAssessmentNotStarted } = useHelpStore()
const { isFromInt } = storeToRefs(useUserStore())
const { handleNotPassed } = useHeaderControlsStore()
</script>

<template>
  <NotPassedAssessment
    v-if="getIsAssessmentNotStarted()"
    @onNotPassed="handleNotPassed"
  />
  <HelpAudioBox v-if="isActiveAudioBox" />
  <LangMenu v-if="!isFromInt" />
</template>
